<template>

<div class="vacancies-item">

    <div class="vacancies-item-text">

        <router-link :to="{name: 'Business/People', params: { slug: item.slug }}" class="vacancies-item-text-name">{{ item.business }} - {{ item.name }}</router-link>

         <div class="vacancies-item-text-detail" v-if="item.type || item.rate">
			<template v-if="item.type">{{ $constants.vacancy[item.type] }}</template>
			<template v-if="item.rate"><template v-if="item.type">, </template>{{ item.rate }}</template>
		</div>

         <div class="vacancies-item-text-description"><com-br tag="p" :text="item.text" /></div>

     </div>

     <div class="vacancies-item-actions">

         <app-button theme="yellow" :expand="true" text="View business" :to="{name: 'Business', params: { slug: item.slug }}" />
         <app-button theme="blue" :expand="true" :text="page.results_more" v-on:click="onApplyClick(item.id)" />

    </div>

</div>

</template>

<script>

import comBR from 'vue-nl2br'

export default {

	props: ['item'],

	components: {
		'com-br': comBR
	},

    methods: {

        onApplyClick: function(id) {

            this.$pubsub.$emit('modal.open', {
                name: 'vacancy/apply',
                vacancy: id
            })

        }

    }

}

</script>

<style scoped>

.vacancies-item {
    border: 1px solid var(--color-grey-light);
    border-radius: 4px;
    padding: 20px;
    margin-bottom: 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
	width: 100%;
}

.is-mobile .vacancies-item {
    flex-direction: column;
	align-items: flex-start;
}

.is-desktop .vacancies-item:hover {
    border-color: var(--color-grey-highlight);
}

.vacancies-item-text {
    flex-grow: 1;
}

.vacancies-item-text-name {
    font-size: 18px;
    color: var(--color-blue-dark);
    line-height: 22px;
    font-family: "grueber",serif;
}

.vacancies-item-text-detail {
    font-size: 14px;
    color: var(--color-grey-dark);
	font-weight: 400;
	margin-bottom: 20px;
}

.vacancies-item-text-description {
    font-size: 14px;
    line-height: 18px;
    color: var(--color-grey-dark);
    font-weight: 300;
}

.vacancies-item-actions {
    width: 160px;
    padding-top: 18px;
    margin-left: 20px;
    flex-shrink: 0;
}

.vacancies-item-actions >>> .button {
	margin-bottom: 4px;
}

.is-mobile .vacancies-item-actions {
	display: flex;
	flex-direction: row;
	width: 100%;
	margin-left: 0px;
}

.is-mobile .vacancies-item-actions >>> .button {
	margin-bottom: 0px;
	flex-grow: 1;
	flex-shrink: 0;
	flex-basis: 0;
	margin: 0px 2px;
}

</style>